export const constants = {} as const;
